import React, { FC, ReactNode } from 'react'
import {
  ClockCircleOutlined,
  EnvironmentOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { T } from '@transifex/react'

import { depotTypeLabelMap, TDepotType } from 'src/api/consts'
import useDelayQuery from 'src/hooks/useDelayQuery'
import { useRoutingHistory } from 'src/reducers/routing/child-router-factory'
import { TagOption } from 'src/storybook/components'
import { array } from 'src/utils/array'

import {
  GetLocationInfoPopover,
  GetLocationInfoPopoverVariables,
} from './__generated__/types'
import { GET } from './api'
import { PopupContentProps } from '..'
import InfoCard from '../components/InfoCard'

const DepotPopup: FC<PopupContentProps> = ({ id }) => {
  const [history, { routingMap }] = useRoutingHistory()
  const { data: { depot } = {}, loading } = useDelayQuery<
    GetLocationInfoPopover,
    GetLocationInfoPopoverVariables
  >(
    GET,
    {
      variables: {
        id,
      },
    },
    300
  )

  const type = depot?.depotType

  return (
    <InfoCard
      title={depot?.name ?? ''}
      avatarProps={{
        src: depot?.logo,
        color: depot?.color,
        shape: 'square',
      }}
      headIcon={<EnvironmentOutlined />}
      headText={<T _str="Locations" />}
      data={array(
        !!depot?.location && {
          icon: (
            <EnvironmentOutlined style={{ color: 'rgba(38, 38, 38, 0.5)' }} />
          ),
          label: depot?.location.name,
        },
        !!depot?.openingTime && {
          icon: (
            <ClockCircleOutlined style={{ color: 'rgba(38, 38, 38, 0.5)' }} />
          ),
          label: `${depot.openingTime} - ${depot.closingTime}`,
        },
        !!depot?.contactPerson?.name && {
          icon: <UserOutlined style={{ color: 'rgba(38, 38, 38, 0.5)' }} />,
          label: (
            <T _str="Contact: {contact}" contact={depot.contactPerson.name} />
          ),
        }
      )}
      tags={array<TagOption | string | ReactNode>(
        type && depotTypeLabelMap[type as TDepotType]
      )}
      onView={() => {
        history.push(
          routingMap.app['fleet-management'].locations[':locationId'](id)._
        )
      }}
      loading={loading}
    />
  )
}

export default DepotPopup
